export const inventoryLink = {
    PROPERTY_POST_INVENTORY_LINK_PENDING  : 'PROPERTY_POST_INVENTORY_LINK_PENDING',
    PROPERTY_POST_INVENTORY_LINK_FULFILLED: 'PROPERTY_POST_INVENTORY_LINK_FULFILLED',
    PROPERTY_POST_INVENTORY_LINK_REJECTED : 'PROPERTY_POST_INVENTORY_LINK_REJECTED',
    PROPERTY_POST_INVENTORY_LINK_CLEAR     : 'PROPERTY_POST_INVENTORY_LINK_CLEAR'
};
